import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconListSegmentedComponent } from "./med-icon-list-segmented.component";

@NgModule({
  declarations: [
    MedIconListSegmentedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconListSegmentedComponent,
  ],
})
export class MedIconListSegmentedModule { }
